import React from "react";
import {IntlMessageValue, UniForm, UniRow} from "../../../../../@WUM/core/Elements";
const Worktime = (props:{value:any}) => {

    return (
        <>
            <UniRow>
                <div>
                    <UniForm.InputGroup class={"mb-3"}>
                        <UniForm.InputGroupText
                            class={""}
                            text={IntlMessageValue("de", "time.settings.worktime", "")}
                        />
                        <UniForm.FormControl
                            type="number"
                            name="worktime"
                            placeholder={IntlMessageValue("","time.settings.worktime.placeholder","")}
                            defaultValue={props?.value?.worktime}
                            min={0}
                            max={60}
                            required
                            step={0.5}
                        />
                        <UniForm.InputGroupText
                            class={"input-unit-field"}
                            text={"h"}
                        />
                        <UniForm.InputGroupHelpText text={"time.settings.worktime.helper"} class={"p-0 pe-1"} Store={""} asPlainText={false} />
                        <UniForm.ControlFeedback text={IntlMessageValue("","time.settings.worktime.save.error","")}/>

                    </UniForm.InputGroup>
                </div>
                <div>
                    <UniForm.InputGroup class={"mb-3"}>
                        <UniForm.InputGroupText
                            class={""}
                            text={IntlMessageValue("", "time.settings.breaktime", "")}
                        />
                        <UniForm.FormControl
                            type="number"
                            name="breaktime"
                            placeholder={IntlMessageValue("","time.settings.breaktime.placeholder","")}
                            defaultValue={props?.value?.breaktime}
                            min={0}
                            max={120}
                            required
                            step={0.5}
                        />
                        <UniForm.InputGroupText
                            class={"input-unit-field"}
                            text={"min"}
                        />
                        <UniForm.InputGroupHelpText text={"time.settings.breaktime.helper"} class={"p-0 pe-1"} Store={""} />
                        <UniForm.ControlFeedback text={IntlMessageValue("","time.settings.breaktime.save.error","")}/>

                    </UniForm.InputGroup>
                </div>
                <div>
                    <UniForm.InputGroup class={"mb-3"}>
                        <UniForm.InputGroupText
                            class={""}
                            text={IntlMessageValue("", "time.settings.holidays", "")}
                        />
                        <UniForm.FormControl
                            type="number"
                            name="vacation"
                            placeholder={IntlMessageValue("","time.settings.holidays.placeholder","")}
                            defaultValue={props?.value?.vacation}
                            min={1}
                            max={40}
                            required
                            step={1}
                        />
                        <UniForm.InputGroupText
                            class={"input-unit-field"}
                            text={"d"}
                        />
                        <UniForm.InputGroupHelpText text={"time.settings.holidays.helper"} class={"p-0 pe-1"} Store={""} />
                        <UniForm.ControlFeedback text={IntlMessageValue("","time.settings.holidays.save.error","")}/>

                    </UniForm.InputGroup>
                </div>

                <div>
                    <UniForm.InputGroup class={"mb-3"}>
                        <UniForm.InputGroupText
                            class={""}
                            text={IntlMessageValue("", "time.settings.worktime-maximum", "")}
                        />
                        <UniForm.FormControl
                            type="number"
                            name="maxWorkTime"
                            placeholder={IntlMessageValue("","time.settings.placeholder.worktime-maximum","")}
                            defaultValue={props?.value?.maxWorkTime}
                            min={0}
                            max={10}
                            required
                            step={0.5}
                        />
                        <UniForm.InputGroupText
                            class={"input-unit-field"}
                            text={"h"}
                        />
                        <UniForm.InputGroupHelpText text={"time.settings.worktime-maximum.helper"} class={"p-0 pe-1"} Store={""} />

                        <UniForm.ControlFeedback text={IntlMessageValue("","time.settings.error.worktime-maximum","")}/>

                    </UniForm.InputGroup>
                </div>

            </UniRow>

        </>
    )
}
export default Worktime;
